export default __webpack_public_path__ + "static/media/gallery_02.db37dc64.jpg";